import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { MissionVision } from "./components/MissionVision";
import { CoreValues } from "./components/CoreValues";
import { Products } from "./components/Products";
import { Technology } from "./components/Technology";
import { CollectionProcess } from "./components/CollectionProcess";
import { Certifications } from "./components/Certifications";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

export default function App() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <MissionVision />
      <CoreValues />
      <Products />
      <Technology />
      <CollectionProcess />
      <Certifications />
      <Contact />
      <Footer />
    </div>
  );
}